"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.on = on;
exports.off = off;
exports.trigger = trigger;
var _callbacks = {};

function on(eventName, callback) {
	if (!_callbacks[eventName]) {
		_callbacks[eventName] = [];
	}
	_callbacks[eventName].push(callback);
}

function off(eventName, callback) {
	var callbacks = _callbacks[eventName];
	if (!callbacks) {
		return;
	}

	var index = -1;
	for (var i = 0; i < callbacks.length; i++) {
		if (callbacks[i] === callback) {
			index = i;
			break;
		}
	}

	if (index < 0) {
		return;
	}

	_callbacks[eventName].splice(index, 1);
}

function trigger(eventName) {
	var callbacks = _callbacks[eventName];
	if (!callbacks || !callbacks.length) {
		return;
	}

	var args = Array.prototype.slice.call(arguments, 1);
	var success = true;
	for (var i = 0; i < callbacks.length; i++) {
		var result = callbacks[i].apply(this, args);
		if (result === false) {
			success = false;
		}
	}
	return success;
}

exports.default = {
	on: on, off: off, trigger: trigger
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/core/event.js
// module id = 74
// module chunks = 0 1